module.exports = __webpack_public_path__ + "img/perzeption-progression.694d2964.svg";